import { useTranslation } from 'react-i18next';
import { Snowflake } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { COLD_CHAIN_PROFILES, formatTemperatureBounds, matchColdChainProfile } from '@/shared/lib/cold-chain';

interface TemperatureRangeBadgeProps {
  min?: number | null;
  max?: number | null;
}

/**
 * Cold chain range as the legacy line description shows it: a snowflake and the bounds, the preset in the tooltip.
 * A cold chain line without bounds still gets the badge, labelled Temperature Controlled.
 */
export const TemperatureRangeBadge = ({ min, max }: TemperatureRangeBadgeProps) => {
  const { t } = useTranslation();
  const coldChainLabel = t('requestline.isColdStorage.label');
  const profile = matchColdChainProfile(min, max);
  const preset = COLD_CHAIN_PROFILES.find(({ id }) => id !== 'OTHER' && id === profile);

  return (
    <Badge title={preset ? t(preset.labelKey) : coldChainLabel}>
      <Snowflake aria-hidden />
      {formatTemperatureBounds(min, max) ?? coldChainLabel}
    </Badge>
  );
};
